import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../localization/labels";
import LocalizationUtil from "../../../../localization/LocalizationUtil";
import { messages } from "../../../../localization/messages";
import PartySubscriptionService from "../../../../services/PartySubscriptionService";
import CommonUtil from "../../../../utils/CommonUtil";
import PathUtil from "../../../../utils/PathUtil";
import { paths } from "../../../paths";
import PageComponent from "../PageComponent";
import Settings from "./Settings";
import PartySession from "../../../../session/PartySession";
import PartyService from "../../../../services/PartyService";

class SettingsContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.partyService = new PartyService(this.keycloak);
    this.partySubscriptionService = new PartySubscriptionService(this.keycloak);

    this.state = this.initialState();
  }

  initialState() {
    return {
      party: undefined,
      oldParty: undefined
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadPartyData();

    this.performCalls();
  }

  loadPartyData = () => {
    this.prepareCall(
      this.partyService.getCurrentParty(
        this.onPartyLoad,
        this.messageHandler.handleError
      )
    );
  };

  onPartyLoad = data => {
    this.setState({ party: { ...data }, oldParty: { ...data } });
    this.loadPartySubscription(data);
  };

  loadPartySubscription = party => {
    if (party?._links?.partySubscription) {
      this.prepareCall(
        this.partySubscriptionService.getEntitiesByUrl(
          party?._links?.partySubscription.href,
          this.onPartySubscriptionLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onPartySubscriptionLoad = data => {
    this.setState({
      party: { ...this.state.party, partySubscription: { ...data } },
      oldParty: { ...this.state.oldParty, partySubscription: { ...data } }
    });
  };

  save = e => {
    e.preventDefault();

    this.prepareCall(
      this.partyService.patchEntity(
        this.state.party,
        this.state.oldParty,
        this.onPartySaved,
        this.messageHandler.handleError
      )
    );

    this.performCalls();
  };

  onPartySaved = party => {
    this.messageHandler.handleSuccess({ text: messages.settingsSaveSuccess });

    this.onPartyLoad(party);

    PartySession.setParty(party);
    this.props.handleClose();

    if (!LocalizationUtil.isLocalized(labels)) {
      window.location.reload();
    }
  };

  savePartySubscription = e => {
    e.preventDefault();

    this.prepareCall(
      this.partySubscriptionService.patchEntity(
        this.state.party.partySubscription,
        this.state.oldParty.partySubscription,
        this.onPartySubscriptionSaved,
        this.messageHandler.handleError
      )
    );

    this.performCalls();
  };

  onPartySubscriptionSaved = partySubscription => {
    this.messageHandler.handleSuccess({ text: messages.settingsSaveSuccess });

    this.onPartySubscriptionLoad(partySubscription);

    this.props.handleClose();
  };

  onChange = event => {
    let state = this.state;
    CommonUtil.setDeepOnStringPath(state, event.target.id, event.target.value);
    this.setState({
      ...state
    });
  };

  onClassificationSubscriptionsClick = () => {
    this.props.handleClose();
    this.changePath(
      PathUtil.jointPath(paths.SUBSCRIPTIONS, paths.CLASSIFICATIONS),
      labels.classificationSubscriptions,
      { from: undefined }
    );
  };

  getComponentTitle = () => {
    return labels.settings;
  };

  openInNewTab() {
    window.open(
      PathUtil.jointPath(paths.SUBSCRIPTIONS, paths.CLASSIFICATIONS),
      "_blank",
      "noopener"
    );
  }

  render() {
    return (
      <Settings
        show={this.props.show}
        handleClose={this.props.handleClose}
        onSave={this.savePartySubscription}
        onChange={this.onChange}
        party={this.state.party}
        onClassificationSubscriptionsClick={
          this.onClassificationSubscriptionsClick
        }
        openInNewTab={this.openInNewTab}
      />
    );
  }
}

export default withKeycloak(withRouter(SettingsContainer));
